import http from "./axios";

// 获取图片地址
export const getQrCodeLink = () => {
  return http.get("/qrCode/getQrCodeLink");
};
